import * as React from 'react';
import * as classNames from 'classnames';
import { GlobalHotKeys } from 'react-hotkeys';
import { KeyboardShortcutTooltip } from '../../../misc/components/KeyboardShortcutTooltip';


interface ScrollActionToggleProps {
    isZoomScroll: boolean;
    onToggleScrollActionClick: () => void;
    isKeyboardShortcutVisible: boolean;
}

export const ScrollActionToggle = (props: ScrollActionToggleProps) => {
    const keyMap = {
        scrollAction: 's',
    }

    const handlers = {
        'scrollAction': () => props.onToggleScrollActionClick(),
    }

    var scrollActionClasses = classNames(
        'fas',
        'fa-fw',
        {
            'fa-toggle-on': props.isZoomScroll,
            'fa-toggle-off': !props.isZoomScroll
        }
    );

    return (
        <>
            <GlobalHotKeys handlers={handlers} keyMap={keyMap} allowChanges />
            <button id="ToggleScrollAction" className="btn btn-primary" style={{ minWidth: 90 + 'px' }} onClick={() => { props.onToggleScrollActionClick() }}>
                <i className={scrollActionClasses} aria-hidden="true"></i>&nbsp;
                {props.isZoomScroll ? "Scroll Action: Zoom" : "Scroll Action: Window" }
                &nbsp;
                <KeyboardShortcutTooltip show={props.isKeyboardShortcutVisible} keyName="S" />
            </button>
        </>
    );
}
